import { useState } from 'react'
import { useNavigate } from 'react-router'
import { toast } from 'sonner'

import Header from 'apps/employer_renewals/components/Header'
import PageContainer from 'apps/employer_renewals/components/layout/PageContainer'
import NavigationButtons from 'apps/employer_renewals/components/NavigationButtons'
import useRenewalEmployees from 'apps/employer_renewals/hooks/useRenewalEmployees'
import { useEmployerRenewalConfig } from 'apps/employer_renewals/providers/EmployerRenewalConfigProvider'
import { usePatchEmployersRenewalsRenewalConfigsIdUpdate } from 'utils/web_api'

import RenewalEmployeesTable from './RenewalEmployeesTable'

export default function ConfirmEligibilityPage () {
  const { renewalConfigId } = useEmployerRenewalConfig()
  const { eligibleEmployeeIds, isLoading, employeeIdsInvitedInCurrentYearWithMissingRequiredInfo } = useRenewalEmployees({})
  const [shakeMissingInfoBanner, setShakeMissingInfoBanner] = useState(false)

  const navigate = useNavigate()

  const updateRenewalConfig = usePatchEmployersRenewalsRenewalConfigsIdUpdate({
    mutation: {
      onSuccess: () => {
        navigate('/employers/employer_renewals/employees/eligibility-confirmed')
      },
      onError: (error) => {
        toast.error('Failed to confirm eligibility', {
          description: 'Please try again. If the problem persists, please contact support.'
        })
        console.error('Failed to confirm eligibility:', error)
      },
    },
  })

  const onConfirm = async () => {
    updateRenewalConfig.mutate({
      id: renewalConfigId,
      data: {
        confirmed_eligibility_at: new Date().toISOString(),
      },
    })
  }

  return (
    <PageContainer maxWidth='lg'>
      <Header
        heading="Confirm who's eligible for healthcare benefits in 2026"
        subheading='Any employees marked as "Eligible" will be automatically invited to enroll in plans on Nov 5.'
      />
      <RenewalEmployeesTable shakeMissingInfoBanner={shakeMissingInfoBanner} />
      <NavigationButtons
        hideBackButton
        nextButtonText={eligibleEmployeeIds.size === 0 ? 'No eligible employees' : `Confirm ${eligibleEmployeeIds.size} eligible employees`}
        isNextDisabled={isLoading || eligibleEmployeeIds.size === 0 || employeeIdsInvitedInCurrentYearWithMissingRequiredInfo.length > 0}
        isLoading={updateRenewalConfig.isPending}
        onNext={onConfirm}
        nextButtonTooltipText={employeeIdsInvitedInCurrentYearWithMissingRequiredInfo.length > 0 ? `${employeeIdsInvitedInCurrentYearWithMissingRequiredInfo.length} employee${employeeIdsInvitedInCurrentYearWithMissingRequiredInfo.length > 1 ? 's are' : ' is'} missing required information. Please update their information before continuing.` : undefined}
        onNextButtonMouseLeave={() => setShakeMissingInfoBanner(false)}
        onNextButtonMouseEnter={() => {
          if (employeeIdsInvitedInCurrentYearWithMissingRequiredInfo.length > 0) {
            setShakeMissingInfoBanner(true)
          }
        }}
      />
    </PageContainer>
  )
}
